import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { IBroadStateSelector } from "source/app/presentation/Shared/ActivePanel/BroadStateSelectors/IBroadStateSelector/IBroadStateSelector";

export const broadStateSelectorData: IBroadStateSelector[] = [
    {
        sharedFunction: ESharedFunction.BroadState_mental,
        verbSymbol: "^",
    },
    {
        sharedFunction: ESharedFunction.BroadState_creativity,
        verbSymbol: "*",
    },
    {
        sharedFunction: ESharedFunction.BroadState_social,
        verbSymbol: ">",
    },
    {
        sharedFunction: ESharedFunction.BroadState_spontaneity,
        verbSymbol: "\\",
    },
    {
        sharedFunction: ESharedFunction.BroadState_physical,
        verbSymbol: "_",
    },
    {
        sharedFunction: ESharedFunction.BroadState_stability,
        verbSymbol: "/",
    },
    {
        sharedFunction: ESharedFunction.BroadState_material,
        verbSymbol: "<",
    },
    {
        sharedFunction: ESharedFunction.BroadState_achievement,
        verbSymbol: "+",
    },
];
